<div class="w-full flex flex-col gap-4 rounded-md border border-gray-200 dark:border-gray-800 p-4 gap-x-4">

    <div class="border-b border-gray-900/10 dark:border-white/10">
        <h2 class="text-lg font-medium">Settings</h2>
        <p class="mb-1 text-sm/6 text-gray-600 dark:text-gray-400">Configure your advertising settings.</p>
    </div>

    <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
        <div class="sm:col-span-4">
            <label for="campaignName" class="block text-sm/6 font-medium text-gray-900 dark:text-white">Campaign
                Name</label>
            <div class="mt-2">
                <input [value]="createSparkCampaignService.campaignName() ?? ''" (input)="onCampaignNameInput($event)"
                    id="campaignName" type="text" name="campaignName" placeholder="Campaign Name"
                    class="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-primary sm:text-sm/6 dark:bg-white/5 dark:text-white dark:outline-white/10 dark:placeholder:text-gray-500 dark:focus:outline-primary" />
            </div>
        </div>

        <div class="sm:col-span-4 flex items-center justify-between">
            <span class="flex grow flex-col">
                <label id="budgetOptimizeOn-label" class="text-sm/6 font-medium text-gray-900 dark:text-white">Campaign
                    budget optimization</label>
                <span id="budgetOptimizeOn-description" class="text-sm text-gray-500 dark:text-gray-400">Automatically
                    optimize your budget allocation. You'll have some limitations on your bid strategy and optimization
                    goal.</span>
            </span>
            <div
                class="group relative inline-flex w-11 shrink-0 rounded-full bg-gray-200 p-0.5 inset-ring inset-ring-gray-900/5 outline-offset-2 outline-primary transition-colors duration-200 ease-in-out has-checked:bg-primary has-focus-visible:outline-2 dark:bg-white/5 dark:inset-ring-white/10 dark:outline-primary dark:has-checked:bg-primary">
                <span
                    class="size-5 rounded-full bg-white shadow-xs ring-1 ring-gray-900/5 transition-transform duration-200 ease-in-out group-has-checked:translate-x-5"></span>
                <input id="budgetOptimizeOn" type="checkbox" name="budgetOptimizeOn"
                    [checked]="createSparkCampaignService.budgetOptimizeOn()" (change)="onBudgetOptimizeChange($event)"
                    aria-labelledby="budgetOptimizeOn-label" aria-describedby="budgetOptimizeOn-description"
                    class="absolute inset-0 size-full cursor-pointer appearance-none focus:outline-hidden" />
            </div>
        </div>

        <!-- budget -->



        <div class="sm:col-span-4">
            <label for="price" class="block text-sm/6 font-medium text-gray-900 dark:text-white">Budget</label>
            <div class="mt-2">
                <div
                    class="flex items-center rounded-md bg-white px-3 outline-1 -outline-offset-1 outline-gray-300 focus-within:outline-2 focus-within:-outline-offset-2 focus-within:outline-primary dark:bg-white/5 dark:outline-white/10 dark:focus-within:outline-primary">
                    <!-- <div class="shrink-0 text-base text-gray-500 select-none sm:text-sm/6 dark:text-gray-400">$</div> -->

                    <el-select id="budget-mode-select" name="budgetMode"
                        [value]="createSparkCampaignService.selectedBudgetMode()" class="w-1/4 block">
                        <button type="button"
                            class="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 sm:text-sm/6 dark:bg-white/5 dark:text-white">
                            <el-selectedcontent class="col-start-1 row-start-1 truncate pr-6">
                                <span class="block truncate">{{
                                    budgetModeLabel(createSparkCampaignService.selectedBudgetMode()) }}</span>
                            </el-selectedcontent>
                            <svg viewBox="0 0 16 16" fill="currentColor" data-slot="icon" aria-hidden="true"
                                class="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4 dark:text-gray-400">
                                <path
                                    d="M5.22 10.22a.75.75 0 0 1 1.06 0L8 11.94l1.72-1.72a.75.75 0 1 1 1.06 1.06l-2.25 2.25a.75.75 0 0 1-1.06 0l-2.25-2.25a.75.75 0 0 1 0-1.06ZM10.78 5.78a.75.75 0 0 1-1.06 0L8 4.06 6.28 5.78a.75.75 0 0 1-1.06-1.06l2.25-2.25a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06Z"
                                    clip-rule="evenodd" fill-rule="evenodd" />
                            </svg>
                        </button>

                        <el-options anchor="bottom start" popover
                            class="max-h-60 w-(--button-width) overflow-auto rounded-md bg-white py-1 text-base shadow-lg outline-1 outline-black/5 [--anchor-gap:--spacing(1)] data-leave:transition data-leave:transition-discrete data-leave:duration-100 data-leave:ease-in data-closed:data-leave:opacity-0 sm:text-sm dark:bg-gray-800 dark:shadow-none dark:-outline-offset-1 dark:outline-white/10">
                            @for (option of budgetModes; track option.value) {
                            <el-option [value]="option.value" (click)="onBudgetModeSelected(option.value)"
                                class="group/option relative block cursor-default py-2 pr-9 pl-3 text-gray-900 select-none focus:bg-primary focus:text-white focus:outline-hidden dark:text-white dark:focus:bg-primary">
                                <span class="block truncate font-normal group-aria-selected/option:font-semibold">{{
                                    option.label }}</span>
                                @if (isBudgetModeSelected(option.value)) {
                                <span
                                    class="absolute inset-y-0 right-0 flex items-center pr-4 text-accent group-focus/option:text-white">
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="size-5">
                                        <path
                                            d="M16.704 4.153a.75.75 0 0 1 .143 1.052l-8 10.5a.75.75 0 0 1-1.127.075l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 0 1 1.05-.143Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </span>
                                }
                            </el-option>
                            }
                        </el-options>
                    </el-select>

                    <input id="price" type="text" name="price" placeholder="0.00" aria-describedby="price-currency"
                        [value]="createSparkCampaignService.budget()" (input)="onBudgetInput($event)"
                        class="border-l border-gray-300 block min-w-0 grow bg-white py-1.5 px-8 pl-4 text-base text-gray-900 placeholder:text-gray-400 focus:outline-none sm:text-sm/6 dark:bg-transparent dark:text-white dark:placeholder:text-gray-500" />
                    <div id="price-currency"
                        class="shrink-0 text-base text-gray-500 select-none sm:text-sm/6 dark:text-gray-400"
                        aria-label="Currency">{{ businessCurrencyCode() }}</div>
                </div>
            </div>
        </div>

    </div>